import { Dictionary, NumericDictionary } from "lodash";
import { IFlag } from "./components/flags-menu/types";

// ----------------------------------------------------------------------------------
//
export interface IAppDefinitions {
    activity: NumericDictionary<DefinitionsActivity>;
    ageCategory: NumericDictionary<DefinitionsAgeCategory>;
    ccs0: Dictionary<DefinitionsCcs0>;
    diagnosis: Dictionary<DefinitionsDiagnosis>;
    diagnosisGroup: Dictionary<DefinitionsDiagnosisGroup>;
    gender: NumericDictionary<DefinitionsGender>;
    insurer: NumericDictionary<DefinitionsInsurer>;
    municipality: Dictionary<DefinitionsMunicipality>;
    careCluster: Dictionary<DefinitionsCareCluster>;
    referrerType: Dictionary<DefinitionsReferrerType>;
    socialStatus: NumericDictionary<DefinitionSocialStatus>;
    specialism: NumericDictionary<DefinitionsSpecialism>;
    ac1: NumericDictionary<DefinitionsAc1>;
    ac2: NumericDictionary<DefinitionsAc2>;
    ac3: NumericDictionary<DefinitionsAc3>;
    trc1: NumericDictionary<DefinitionsTrc1>;
    trc2: NumericDictionary<DefinitionsTrc2>;
    trc3: NumericDictionary<DefinitionsTrc3>;
    rve: NumericDictionary<DefinitionsRve>;
    comorbidityIndex: Dictionary<DefinitionsComorbidityIndex>;
    urgencyCare: NumericDictionary<DefinitionsUrgencyCare>;
    flag: NumericDictionary<DefinitionsFlag>;
    bestPracticesFlag: NumericDictionary<DefinitionsFlag>;
    referral: NumericDictionary<DefinitionsReferral>;
    location: Dictionary<DefinitionsLocation>;
}

// ----------------------------------------------------------------------------------
//
export interface DefinitionsItemBase<TCode> {
    code: TCode;
    name: string;
}

// ----------------------------------------------------------------------------------
//
export interface DefinitionsActivity extends DefinitionsItemBase<string> {
    ac3_code: number;
    display_code: string;
}

export interface DefinitionsAgeCategory {
    code: number;
    name: string;
}

export interface DefinitionsCcs0 extends DefinitionsItemBase<string> {}

export interface DefinitionsDiagnosisGroup extends DefinitionsItemBase<string> {
    ccs0_code: string;
    zorgcluster_code: number;
}

export interface DefinitionsDiagnosis extends DefinitionsItemBase<string> {
    specialism_code: string;
    display_code: string;
}

export interface DefinitionsGender extends DefinitionsItemBase<number> {}

export interface DefinitionsInsurer extends DefinitionsItemBase<number> {}

export interface DefinitionsMunicipality extends DefinitionsItemBase<string> {}

export interface DefinitionsCareCluster extends DefinitionsItemBase<number> {}

export interface DefinitionsReferrerType extends DefinitionsItemBase<string> {}

export interface DefinitionSocialStatus extends DefinitionsItemBase<number> {}

export interface DefinitionsSpecialism extends DefinitionsItemBase<string> {
    abbreviation: string;
    display_code: string;
}

export interface DefinitionsRve extends DefinitionsItemBase<string> {}

export interface DefinitionsAc1 extends DefinitionsItemBase<number> {
    abbr: string;
    sort_order: number;
}

export interface DefinitionsAc2 extends DefinitionsItemBase<number> {
    abbr: string;
    ac1_code: number;
    sort_order: number;
}

export interface DefinitionsAc3 extends DefinitionsItemBase<number> {
    abbr: string;
    ac2_code: number;
    sort_order: number;
}

export interface DefinitionsTrc1 extends DefinitionsItemBase<number> {
    abbr: string;
    sort_order: number;
    display_code: string;
}

export interface DefinitionsTrc2 extends DefinitionsItemBase<number> {
    abbr: string;
    trc1_code: number;
    sort_order: number;
    is_expandable: boolean;
    display_code: string;
}

export interface DefinitionsTrc3 extends DefinitionsItemBase<number> {
    abbr: string;
    trc2_code: number;
    sort_order: number;
}
export interface DefinitionsUrgencyCare extends DefinitionsItemBase<number> {
    nza_urgency_id: number;
}

export interface DefinitionsComorbidityIndex extends DefinitionsItemBase<string> {
    code: string;
    description: number;
}

export interface DefinitionsFlag extends DefinitionsItemBase<number>, IFlag {
    // type?: number;
}

export interface DefinitionsReferral extends DefinitionsItemBase<number> {}

export interface DefinitionsLocation {
    name: string;
}
